import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AuthState from "./context/auth/AuthState";
import { BrowserRouter as Router } from "react-router-dom";
import Authentication from "./components/Authentication";
import { UserProvider } from "./context/auth/UserContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <AuthState>

        <UserProvider>
          <App />
        </UserProvider>
      </AuthState>
    </Router>
  </React.StrictMode>
);
